import { render, staticRenderFns } from "./mProveRawData.vue?vue&type=template&id=72d9c7ae&class=p-1&"
import script from "./mProveRawData.vue?vue&type=script&lang=js&"
export * from "./mProveRawData.vue?vue&type=script&lang=js&"
import style0 from "./mProveRawData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/mProveRawData.vue
// module id = null
// module chunks = 